import { makeStyles } from '@material-ui/core/styles';

export const useTabbedCardTabPanelStyles = makeStyles((muiTheme) => ({
  root: {
    '& .card-row': {
      display: 'grid',
      marginBottom: 0,
      gridTemplateColumns: '1fr',
      gap: '16px',
      [muiTheme.breakpoints.up('md')]: {
        marginBottom: '24px',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '40px',
        '&.card-row-featured': {
          gap: '24px',
          gridTemplateColumns: '353px repeat(3, 1fr)',
        },
      },
    },
    '& .MuiCard-root': {
      flex: 1,
      '& .MuiCardContent-root': {
        padding: '20px 20px 16px 20px',
      },
      '& .MuiCardHeader-root': {
        padding: muiTheme.spacing(3, 3, 1),
      },
      '& .MuiCardMedia-root': {
        marginBottom: muiTheme.spacing(1),
      },
      '& .MuiCardActions-root': {
        padding: '0 20px 20px',
        '& *': {
          fontSize: '14px',
          lineHeight: '14px',
        },
      },
      '& .card-content-wrapper': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      },
      '& .rich-text': {
        '& p': {
          fontSize: '14px',
          lineHeight: '22px',
        },
      },
    },
  },
  tabbedCard: {
    minHeight: '170px',
    [muiTheme.breakpoints.up('md')]: {
      minHeight: 'initial',
    },
  },
  contentHeadingWrapper: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    marginBottom: '16px',
    '& .MuiAvatar-root': {
      width: '24px',
      height: '24px',
      '& .MuiAvatar-img': {
        objectFit: 'contain',
      },
    },
  },
  contentHeading: {
    fontSize: '18px',
    lineHeight: '18px',
  },
  contentDescription: {},
}));
